import React, {useEffect, useRef, useState} from 'react';
import {AllResources, MainResources, Resource} from "../../models/Resources";
import {Header} from "../general/Header";
import MDSpinner from "react-md-spinner";
import {spinnerColor} from "../../utils/StyleUtils";
import {preloadResource} from "../../utils/URLUtils";
import {MainScreen} from "./MainScreen";
import Features from "../features";
import {Reviews} from "./Reviews";
import {TryApp} from "./TryApp";
import {Questions} from "./Questions";
import {Footer} from "./Footer";
import {isMobile} from 'react-device-detect';
import Cookies from "../general/Cookies";

const Main = ({}) => {
    const [isLoadingResources, setIsLoadingResources] = useState(true)

    const mainRef = useRef(null);

    useEffect(() => {
        const loadResources = (resource: Resource) => {
            return new Promise((resolve, reject) => {
                preloadResource(resource.src).then((src) => {
                    resource.blobSrc = src;
                    resolve(src);
                })
            })
        }

        Promise.all(Object.values(AllResources).map(resource => loadResources(resource)))
            .then(() => setIsLoadingResources(false))
            .catch(err => console.log("Failed to load images", err))
    }, [])
  return (
      <div ref={mainRef}>
          <Header/>
          {
              isLoadingResources ?
                  <div className='spinner-container' style={{height: '100VH'}}>
                    <MDSpinner size={100} singleColor={spinnerColor}/>
                 </div> : [
                     <MainScreen/>,
                        <div key={'len1'} className="video-section" style={{height: '357px'}}>
                            <video src={MainResources.len1.blobSrc} autoPlay={true} muted playsInline loop onError={err => {
                                console.error('Video load error. ' + err);
                            }}>
                            </video>
                            <div>
                                Make trendy content with unique filters and get professional look in just one tap.
                            </div>
                        </div>,
                      <Features
                          mainRef={mainRef}
                      />,
                      <div className="video-section">
                          <video src={MainResources.len2.blobSrc} autoPlay={true} muted playsInline loop onError={err => {
                              console.error('Video load error. ' + err);
                          }}>
                          </video>
                      </div>,
                      <Reviews/>,
                      <TryApp/>,
                      <Questions/>,
                      <Footer/>,
                      <Cookies/>
                  ]
          }
      </div>
  );
};

export default Main;

